import $ from 'jquery';

function Forms(){
    var n = 0;
    $('form #email').on('input', function(){
        window['value'+n] = new Date();
        n = n + 1;
        // console.log(value0);
    });

    $(".form-check").on('submit', function(e){
        e.preventDefault();
        var thisForm = $(this);
        var te = new Date();
        var timeSpent = Math.abs(value0 - te);
        // console.log(timeSpent);
        $(this).find('button.next').prop("disabled", true).html('Envoi en cours <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>');

        if(timeSpent > 1500){
            var emailCheck = thisForm.find("input[name='check']").val();
            console.log(emailCheck);
            // var code_postal = thisForm.find("input[name='code_postal']").val();
            if(emailCheck.length === 0){
                var formData = {};
                thisForm.find("input:not([type=radio]), input[type='radio']:checked, textarea, select").each(function(){
                    formData[this.name] = this.value;
                });
                // console.log(formData);

                if(thisForm.hasClass('form-devis')){
                    var titleSuccess = 'Merci pour votre demande de devis :)';
                    var textSuccess = 'Vous allez recevoir entre 1 et 5 devis personnalisés dans votre boîte de réception dans les 24 heures.<br>À très bientôt !';
                    var titleError = 'Une erreur est survenue';
                    var textError = "Une erreur inconnue est survenue. Veuillez réitérer votre demande de devis. Si l'erreur venait à persister, veuillez nous contacter par email à <a href='mailto:info@achyl.be'>info@achyl.be</a>. À bientôt.";

                    $.ajax({
                        type: 'POST',
                        data: formData,
                        url: belgiqueentreprisesData.root_url + '/php/form-devis.php',
                        success: function(sent) {
                            console.log(sent);
                          if(sent == "sent"){
                            thisForm.find('.finalSlide h3').html(titleSuccess);
                            thisForm.find('.finalSlide p').html(textSuccess);
                            toFinalSlide(thisForm);
        
                            // gtag('event', 'Demande de devis', {
                            //     'event_category': 'Demande de devis',
                            //     'event_label': email
                            // });
                            // var event_name = "quote_sent";
                            // var properties = {
                            // 'email': email,
                            // }
                            // sendinblue.track(
                            //     event_name, /*mandatory*/
                            //     properties /*optional*/
                            // )
    
                          }
                          else{
                            thisForm.find('.finalSlide h3').html(titleError);
                            thisForm.find('.finalSlide p').html(textError);
                            toFinalSlide(thisForm);
                          }
                        },
                        error: (response) => {
                            console.log(response);
                        },
                    });
                }

                if(thisForm.hasClass('form-ajouter-entrepreneur')){
                    var titleSuccess = 'Bienvenue ! :)';
                    var textSuccess = 'Votre inscription a bien été enregistrée. Vous apparaissez déjà dans notre base de données et dans la catégorie que vous avez sélectionnée.';
                    var titleError = 'Une erreur est survenue';
                    var textError = "Une erreur inconnue est survenue. Veuillez réitérer votre demande d'inscription. Si l'erreur venait à persister, veuillez nous contacter par email à <a href='mailto:info@achyl.be'>info@achyl.be</a>. À bientôt.";

                    $.ajax({
                        type: 'POST',
                        data: formData,
                        url: belgiqueentreprisesData.root_url + '/php/form-ajouter-entrepreneur.php',
                        success: function(sent) {
                            console.log(sent);
                          if(sent == "sent"){
                            thisForm.find('.finalSlide h3').html(titleSuccess);
                            thisForm.find('.finalSlide p').html(textSuccess);
                            toFinalSlide(thisForm);
                          }
                          else{
                            thisForm.find('.finalSlide h3').html(titleError);
                            thisForm.find('.finalSlide p').html(textError);
                            toFinalSlide(thisForm);
                          }
                        },
                        error: (response) => {
                            console.log(response);
                        },
                    });
                }
            }
        }
    });

    function toFinalSlide(thisForm){
        thisForm.find('.slide, .carousel__header, .carousel__footer').css('display', 'none');
        thisForm.css('justify-content', 'center');
        thisForm.find('.finalSlide').css('display', 'block');
    }
}

export default Forms;